// extracted by mini-css-extract-plugin
export default {"container":"SettingsSectionFooter-module__container--Eu3Ao"};